export default {
  // sm: `
  // 막대한 양의 데이터를 물리적인 서버에서 다루는
  // 것은 비용과 시간이 많이 들어갑니다. 이에 네이버는
  // 클라우드를 활용하여 가상의 IT 자원을 자유자재로
  // 늘려 효율적인 클라우드 플랫폼 서비스를 제공하고
  // 있습니다.
  // `,
  // md: `
  // 막대한 양의 데이터를 물리적인 서버에서
  // 다루는 것은 비용과 시간이  많이 들어갑니다.
  // 이에 네이버는 클라우드를 활용하여 가상의
  // IT 자원을 자유자재로 늘려 효율적인 클라우드
  // 플랫폼 서비스를 제공하고 있습니다.
  // `,
  // xxl: `
  // 막대한 양의 데이터를 물리적인 서버에서 다루는 것은
  // 비용과 시간이  많이 들어갑니다. 이에 네이버는
  // 클라우드를 활용하여 가상의 IT 자원을 자유자재로 늘려
  // 효율적인 클라우드 플랫폼 서비스를 제공하고 있습니다.
  // `,
};
